// extracted by mini-css-extract-plugin
export var pOutput = "output-module--p-output--VUiWi";
export var visible = "output-module--visible--TOZ7h";
export var subcopyBefore = "output-module--subcopy-before--3HQyq";
export var subcopyAfter = "output-module--subcopy-after--2YSn3";
export var oOutputProcess = "output-module--o-output-process--3gIHN";
export var outputProcess = "output-module--output-process--acKYS";
export var standby = "output-module--standby--12V7j";
export var lContent__inner = "output-module--l-content__inner--3Dt9Y";
export var single = "output-module--single--2nNhT";
export var extra = "output-module--extra--1sQpc";
export var oOutput = "output-module--o-output--2j2SH";
export var icon = "output-module--icon--3yD_V";